"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartDialog = void 0;
var react_1 = __importDefault(require("react"));
var Cart_1 = require("./Cart");
function CartDialog(_a) {
    var open = _a.open, onClose = _a.onClose;
    return (react_1.default.createElement("div", { className: "modal fade", id: "shopcart", tabIndex: -1, role: "dialog", "aria-labelledby": "shopcartLabel", "aria-hidden": "true" },
        react_1.default.createElement("div", { className: "modal-dialog modal-lg", role: "document" },
            react_1.default.createElement("div", { className: "modal-content" },
                react_1.default.createElement("div", { className: "modal-header border-top-0" },
                    react_1.default.createElement("h5", { className: "modal-title", id: "shopcartLabel" }, "WINKELWAGEN"),
                    react_1.default.createElement("button", { type: "button", className: "close", "data-dismiss": "modal", "aria-label": "Close" },
                        react_1.default.createElement("span", { "aria-hidden": "true" }, "\u00D7"))),
                react_1.default.createElement("div", { className: "modal-body" },
                    react_1.default.createElement(Cart_1.Cart, null)),
                react_1.default.createElement("div", { className: "modal-footer border-top-0" },
                    react_1.default.createElement("a", { href: "shop.html", className: "btn btn-blue" }, "Verder winkelen"),
                    react_1.default.createElement("button", { type: "button", className: "btn btn-green2", "data-dismiss": "modal", "aria-label": "Close" }, "Afrekenen"))))));
}
exports.CartDialog = CartDialog;
